import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import './Breadcrumb.css';

const getBreadcrumbPathList = currentPath => {

    const breadCrumbs = [];

    if (
        currentPath === 'CHOOSEPLAN'
        || currentPath === 'ORDER'
        || currentPath === 'TRACKSALESORDER'
        || currentPath === ''
    ) {

        return breadCrumbs;
    }

    breadCrumbs.push({ path: '/cloud/fibre/sales/choosePlan', title: 'Choose a fibre plan' });

    if (currentPath === 'PLANDETAILS' || currentPath === 'VUMATELPLANDETAILS') {
        
        return breadCrumbs;
    }

    if (currentPath === 'VUMACONTACTINFORMATION') {

        breadCrumbs.push({ path: '/cloud/fibre/sales/vumatelplanDetails', title: 'Plan Details' });
    }
    else {

        breadCrumbs.push({ path: '/cloud/fibre/sales/planDetails', title: 'Plan Details' });
    }

    if (currentPath === 'DELIVERYADDRESS' || currentPath === 'VUMACONTACTINFORMATION') {
        
        return breadCrumbs;
    }

    breadCrumbs.push({ path: '/cloud/fibre/sales/deliveryAddress', title: 'Confirm delivery address' });

    return breadCrumbs;
}

const Breadcrumb = ({ currentPath, currentPathTitle }) => {

    const breadCrumbs = getBreadcrumbPathList(currentPath);

    const homeClickHandler = () => {
        window.location.href = '/vodacom/fibre/sales/leads';
    }

    return (
        <div className="breadcrumb__container">
            <ul className="breadcrumb__breadcrumb-list">
                <li>
                    <span style={{ cursor: 'pointer' }} onClick={homeClickHandler} className="breadcrumb__prev-path">Home</span>
                </li>

                {
                    breadCrumbs.map(item =>
                        <li key={item.path}>
                            <Link className="breadcrumb__prev-path" to={item.path}>{item.title}</Link>
                        </li>
                    )
                }
                <li>
                    <a className="breadcrumb__current-path">{currentPathTitle}</a>
                </li>
            </ul>
        </div>
    );
}

Breadcrumb.propTypes = {
    currentPath: PropTypes.string,
    currentPathTitle: PropTypes.string,
};

export default Breadcrumb;
